export default {
  activeScale: state => {
    return state.activeData.scale;
  },
  activeSector: state => {
    return state.activeData.sector;
  },
  activeMapView: state => {
    return state.activeData.scale.center;
  },
  isSuitabilityLayerVisible: state => {
    return state.wmsLayerSuitability.visible;
  },
  roundedMarkerCoords: state => {
    return {
      lon: Number(state.marker.lon).toFixed(4),
      lat: Number(state.marker.lat).toFixed(4)
    };
  }
};
